import axios from "axios";

// Base API URL
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://arxed.info";

// Create a preconfigured axios instance for API calls
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Important for IAP authentication
  headers: {
    "Content-Type": "application/json",
  },
});

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle IAP authentication redirects
    if (error.response && error.response.status === 302) {
      // If we're on the login page already, don't redirect again
      if (!window.location.hash.includes("#/")) {
        window.location.href = API_BASE_URL;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
